export var Browser;
(function (Browser) {
    Browser["CHROME"] = "CHROME";
    Browser["EDGE"] = "EDGE";
    Browser["FIREFOX"] = "FIREFOX";
    Browser["IE"] = "IE";
    Browser["OPERA"] = "OPERA";
    Browser["SAFARI"] = "SAFARI";
})(Browser || (Browser = {}));
